export default __webpack_public_path__ + "static/media/image_large.446e7c49.png";